/**
 * Brand imagery — real photos from Les Artisans Sucrés.
 * Replace any URL here with a new photo and it updates everywhere.
 */
export const media = {
  logo: 'https://cdn.magicpatterns.com/uploads/wZEDXnWuT9mQ24Ujkh4R7j/Logo_format_PNG.png',

  /** Real cacao — from the tree to the roasted bean. */
  cacaoPod:
    'https://cdn.magicpatterns.com/patterns/generated-images/f7643848-d58e-4e37-942c-28e53d86f69f.jpg',
  cacaoOpen:
    'https://cdn.magicpatterns.com/patterns/generated-images/932fe51c-d4bd-4d55-b754-a7e6596e8e4b.jpg',
  cacaoBeans:
    'https://cdn.magicpatterns.com/patterns/generated-images/9916f558-1578-43b5-be5e-485d65d912b9.jpg',

  /** Hand-painted heart bonbons in a gift box. */
  bonbonsCoeurs:
    'https://cdn.magicpatterns.com/uploads/tzSbG7amhiEz5uLgicdFSd/chcolates_corazon_celestes.jpg',
  /** Green marbled bonbons with a praline centre. */
  bonbonsVerts:
    'https://cdn.magicpatterns.com/uploads/9j4BTJfnfQ1Zb52LGvM5LW/chcolates_reptiles.jpg',

  /** Signature alfajores glazed in white chocolate with pecan, cranberry and coconut. */
  alfajores:
    'https://cdn.magicpatterns.com/uploads/dcHePQxHtnnmyCZuHAZ8VF/Copilot_20260604_123355.png',
  alfajoresCloseUp:
    'https://cdn.magicpatterns.com/uploads/eQ9yocELgfK8QwNL3756n3/Copilot_20260604_123217.png',
  alfajoresJam:
    'https://cdn.magicpatterns.com/uploads/4vzV75YXM5Qkjexze6zsLM/BCO.ff91ff99-bfc5-4ba9-8491-4a03789a414c.png',
  alfajoresBoard:
    'https://cdn.magicpatterns.com/uploads/rMrz4pwupZ2EveBEQqWKti/alfajores_en_tabla.png',
  /** Alfajores dulce de leche & strawberry jam, dusted with icing sugar. */
  alfajoresConfiture:
    'https://cdn.magicpatterns.com/uploads/kJb1PqZgktK6pbKrHTRntB/BCO.ff91ff99-bfc5-4ba9-8491-4a03789a414c.png',
  /** Alfajores coated in white chocolate with cranberries and nuts. */
  alfajoresChocolatBlanc:
    'https://cdn.magicpatterns.com/uploads/gdauR4QfVZyTTKHUTZ5HZW/Copilot_20260604_123217.png',
  /** Alfajores coated in milk and white chocolate — assortment. */
  alfajoresChocolatLait:
    'https://cdn.magicpatterns.com/uploads/6a4euDuFqB9q4SNwBRJNdJ/Capture_d’ecran_2026-07-05_010053.png',
  /** Alfajores coated in dark chocolate with almonds and cranberries. */
  alfajoresChocolat:
    'https://cdn.magicpatterns.com/uploads/7cP1qxAdQEpgTXELbVidbF/IMG_4734.jpg',
  /** Classic dulce de leche alfajores. */
  alfajoresClassiques:
    'https://cdn.magicpatterns.com/uploads/etbjWXrkbVAGBgycJPt5JD/Copilot_20260604_124416.png',

  /** Two hands holding one of our alfajores. */
  hands:
    'https://cdn.magicpatterns.com/patterns/generated-images/0358ebd0-9dea-47c0-acf3-65b61d7da0c9.jpg',

  /** Fine hand-painted bonbons. */
  bonbonsFins:
    'https://cdn.magicpatterns.com/uploads/cQG7sSEs83DjvR1AZf1gUd/Capture_d’ecran_2026-08-19_173326.png',
  /** Fruit-filled bonbons. */
  bonbonsFruits:
    'https://cdn.magicpatterns.com/uploads/oCRB8qrJx9US9iZdMRsKrq/Capture_d’ecran_2026-08-19_173509.png',
  /** Homemade nut pralines / mendiants. */
  pralines:
    'https://cdn.magicpatterns.com/uploads/ksYmQE1j4bjVygRGJwLysy/Capture_d’ecran_2026-08-19_173554.png',
  /** Praline bonbons, hand-marbled in amber and plum. */
  bonbonsPralines:
    'https://cdn.magicpatterns.com/uploads/mzAsBV6cViEnPZsNRLmvJU/chocolate_naranjados.png',
  /** Marbled bonbon cut open on a lucuma centre. */
  bonbonsFruitsCoeur:
    'https://cdn.magicpatterns.com/uploads/gY5QpgGAVSngYYcpSmBW2f/chocolucuma.png',
  /** Coconut bonbon with a passion fruit centre. */
  bonbonsCocoPassion:
    'https://cdn.magicpatterns.com/uploads/7FMFaLWh2yLLBh6FqNqBkC/chocolae_coco_con_maracuya.png',
  /** Chocotejas — long chocolate batons filled with hazelnut. */
  chocotejas:
    'https://cdn.magicpatterns.com/uploads/1pEqURQMoeUu7JBboBD7VY/baston_con_nucces.png',

  /** Pretzels coated in chocolate. */
  pretzelsNoir:
    'https://cdn.magicpatterns.com/uploads/5MAAbyi24NwzLg61vxwy3e/pretzel_lehce.png',
  pretzelsBlanc:
    'https://cdn.magicpatterns.com/uploads/iWUWfAmRA4uYGDqYmeezKn/pretsel_blanco.png',

  /** Chocolate bars. */
  tablettesAssorties:
    'https://cdn.magicpatterns.com/uploads/bGopWr2BBPXrjx26sCerut/Capture_d’ecran_2026-08-19_173835.png',
  tabletteBlanche:
    'https://cdn.magicpatterns.com/patterns/generated-images/827d6675-4151-48aa-a5cc-da120193a260.jpg',
  tabletteLait:
    'https://cdn.magicpatterns.com/patterns/generated-images/ce65c494-1d64-4229-90d2-3f0b82223b31.jpg',
  tabletteNoire:
    'https://cdn.magicpatterns.com/patterns/generated-images/bfda5309-7546-475c-b4f8-877b8d394c5c.jpg',

  /** Cake pops. */
  cakepops:
    'https://cdn.magicpatterns.com/uploads/wNP7oAKXneqJSjYvdYSRLb/Cake_pop_retouche.png',

  /** Older chocolate photos, still used across the site. */
  chocolats:
    'https://cdn.magicpatterns.com/uploads/eqwFzBGVJcbkUaU5UhGBah/chcolates_caja_2_.png',
  chocolatBars:
    'https://cdn.magicpatterns.com/uploads/hy9aG2F6axDtohfPvFYzgY/fotos_chcoo_largos_.png',
  chocolatsCollage:
    'https://cdn.magicpatterns.com/uploads/j2FAEE2w2SHsW75hG2MGH8/nuevo_affiche_choco.jpg',

  /** Gift boxes for corporate orders and events. */
  giftBoxes:
    'https://cdn.magicpatterns.com/uploads/1aSrBbjqUAYfp2JkJbMF7T/chocolates_caja_.png',
} as const
